import React from 'react';
import {useTranslation} from 'react-i18next';
const NoAccessPage = () => {
  const { t } = useTranslation();
  return (
     <div className="unauthorized-container">
      <div className="no-access-page">
      <div className="no-access-page-logo">
        <img src="/assets/supercoach-logo-stacked.png" alt="Supercoach Logo" />
      </div>

      <div className="no-access-page-title">
        <h1>{t('noAccess.title')}</h1>
        <p>
          {t('noAccess.message')}
        </p>
      </div>


      <a
  href={`mailto:Hello@supercoachapp.com?subject=${encodeURIComponent("Request Access")}`}
  className="button button-add"
>
  {t('noAccess.request_access')}
</a>

      </div>
    </div>

  );
};

export default NoAccessPage;